import type { ImageLoader } from 'next/image';
import bunnyImageLoader from '../../../loader';

// Match the deliberately narrow optimizer allowlist in next.config.js. Other
// admin sources (including SVG/local assets) retain the existing Bunny path.
export function isSameOriginHeroSource(src: string): boolean {
  try {
    const url = new URL(src);
    return url.protocol === 'https:' &&
      url.hostname === 'api.modralekaren.sk' &&
      url.port === '' && url.username === '' && url.password === '' && url.hash === '' &&
      url.pathname.startsWith('/files/') &&
      /\.(?:avif|gif|jpe?g|png|webp)$/i.test(url.pathname) &&
      ['', '?ai=0', '?ai=1'].includes(url.search);
  } catch {
    return false;
  }
}

export const sameOriginHeroLoader: ImageLoader = ({ src, width, quality }) => {
  if (!isSameOriginHeroSource(src)) return bunnyImageLoader({ src, width, quality });
  // Same URL encoding/width/quality contract as Next's default image loader;
  // the original admin URL is not rewritten or stripped of its ai query.
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality ?? 75}`;
};

export function getHeroImageLoader(src: string, failed = false): ImageLoader | undefined {
  // undefined delegates to the unchanged global Bunny loaderFile.
  return !failed && isSameOriginHeroSource(src) ? sameOriginHeroLoader : undefined;
}
